import type {ReferralSelectedQuestionnaire} from 'src/types/referral-v2';
import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  BodyMedium,
} from '@spaced-out/ui-design-system/lib/components/index';
import css from 'src/components/referrer-portal/my-referrals/tracking.css';


const AdditionalQuestionModal = ({
  isOpen,
  onClose,
  handleSubmit,
  customQuestions,
}: {
  isOpen: boolean;
  onClose: () => unknown;
  handleSubmit: (arg1: {[key: string]: string}) => unknown;
  customQuestions: ReferralSelectedQuestionnaire[] | null | undefined;
}) => {
  const [formData, setFormData] = React.useState<{
    [key: string]: string;
  }>({});
  const [errors, setErrors] = React.useState(new Map());
  const {t} = useLabelTranslation();

  const validateForm = (formData: {[key: string]: string}) => {
    const newErrors = new Map();

    customQuestions?.forEach(
      (customQuestion: ReferralSelectedQuestionnaire) => {
        const value = formData[customQuestion.response_field];
        if (customQuestion && !customQuestion.is_optional && !value) {
          newErrors.set(customQuestion.response_field, true);
        }
      },
    );
    setErrors(newErrors);
    return newErrors;
  };

  const handleChange = (
    fieldName: string,
    value: string | null | undefined | string[],
  ) => {
    const updatedFormData = {...formData, [fieldName]: value} as const;
    // @ts-expect-error - TS2345 - Argument of type '{ readonly [x: string]: string | string[] | null | undefined; }' is not assignable to parameter of type 'SetStateAction<{ [key: string]: string; }>'.
    setFormData(updatedFormData);
    // @ts-expect-error - TS2345 - Argument of type '{ readonly [x: string]: string | string[] | null | undefined; }' is not assignable to parameter of type '{ [key: string]: string; }'.
    validateForm(updatedFormData);
  };

  const onSubmit = () => {
    const error = validateForm(formData);
    if (error.size > 0) {
      return;
    }
    handleSubmit(formData);
  };

  return (
    <Modal size="large" isOpen={isOpen} onClose={onClose}>
      <ModalHeader onCloseButtonClick={onClose}>
        {t('Additional_Details', 'Additional Details')}
      </ModalHeader>
      <ModalBody className={css.flexColumn}>
        <BodyMedium>{`${t(
          'The_company_you\'re_submitting_to_would_love_to_learn_more_about_you_Please_provide_additional_details_to_help_them_get_to_know_you_better',
          'The company you\'re submitting to would love to learn more about you! Please provide additional details to help them get to know you better',
        )}.`}</BodyMedium>
        <div className={css.inputBox}>
          {customQuestions?.map((question: ReferralSelectedQuestionnaire) => {
            return (
              <Input
                value={formData[question.response_field]}
                required={!question.is_optional}
                label={question.value}
                error={errors.has(question.response_field)}
                errorText={t('Field_is_required', 'Field is required')}
                onChange={(event) =>
                  handleChange(question.response_field, event.target.value)
                }
              />
            );
          })}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button type="tertiary" onClick={onClose}>
          {t('Cancel', 'Cancel')}
        </Button>
        <Button onClick={onSubmit}>
          {t('Submit_Referral', 'Submit Referral')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AdditionalQuestionModal;
